var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.8584 14.5013L21.0537 9.30599C21.3003 9.05985 21.4389 8.72585 21.4393 8.37746C21.4396 8.02907 21.3015 7.69482 21.0553 7.44825C20.8092 7.20168 20.4752 7.06299 20.1268 7.06268C19.7784 7.06238 19.4442 7.20048 19.1976 7.44661L14.0023 12.6419L8.80696 7.44661C8.5604 7.20004 8.22598 7.06152 7.87728 7.06152C7.52858 7.06152 7.19416 7.20004 6.94759 7.44661C6.70102 7.69318 6.5625 8.0276 6.5625 8.3763C6.5625 8.725 6.70102 9.05942 6.94759 9.30599L12.1429 14.5013L6.94759 19.6966C6.70102 19.9432 6.5625 20.2776 6.5625 20.6263C6.5625 20.975 6.70102 21.3094 6.94759 21.556C7.19416 21.8026 7.52858 21.9411 7.87728 21.9411C8.22598 21.9411 8.5604 21.8026 8.80696 21.556L14.0023 16.3607L19.1976 21.556C19.4442 21.8026 19.7786 21.9411 20.1273 21.9411C20.476 21.9411 20.8104 21.8026 21.057 21.556C21.3035 21.3094 21.4421 20.975 21.4421 20.6263C21.4421 20.2776 21.3035 19.9432 21.057 19.6966L15.8584 14.5013Z",
    fill: "#1F1F1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.76304296c131a26406d49659934ed8d6.svg";
export { ForwardRef as ReactComponent };